import { Component, forwardRef, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { isOnline } from '../../common/setup';
import { TicketStatus } from '../../model';
import { TicketService } from '../../service/ticket.service';

@Component({
    selector: 'ticket-counter',
    template: require('./ticket-counter.component.html')
})
export class TicketCounterComponent implements OnInit, OnDestroy {

    count: number;

    private intervalId: any;
    private TICKET_COUNT_REFRESH_INTERVAL = 5 * 60 * 1000; // 5 minutes

    constructor(
        @Inject(forwardRef(() => NgZone)) private zone: NgZone,
        @Inject(forwardRef(() => TicketService)) private ticketService: TicketService
    ) { }

    ngOnInit(): void {
        if (this.ticketService.canReceiveTickets() && isOnline()) {
            this.updateTicketCount();
            this.zone.runOutsideAngular(() => {
                this.intervalId = setInterval(() => this.updateTicketCount(), this.TICKET_COUNT_REFRESH_INTERVAL)
            });
        }
    }

    protected updateTicketCount(): void {
        this.ticketService.getTickets(0, 1, null, true, null, [TicketStatus.OPEN, TicketStatus.IN_PROGRESS, TicketStatus.ON_HOLD]).then(resp => {
            this.zone.run(() => this.count = resp.totalElements);
        });
    }

    ngOnDestroy(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

}